import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from './store'


require('@/utils/CustomUtil')

import ElementUI from "element-ui";
import vueEsign from 'vue-esign'
import "element-ui/lib/theme-chalk/index.css";

import "@/assets/theme.less";
import "@/assets/global.css";
import "@/assets/iconfont/iconfont.css"
import "@/assets/iconfont/icon.css"
import Ellipsis from '@/components/common/Ellipsis'
import WDialog from '@/components/common/WDialog'
import Tip from '@/components/common/Tip'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueScrollTo from 'vue-scrollto'
import './assets/svg/index'
import './assets/element-variables.scss'
// 全局注册（必须执行这一步，指令才会生效）

Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(Ellipsis);
Vue.use(WDialog);
Vue.use(Tip);
Vue.use(vueEsign);
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

  Vue.config.productionTip = false

  Vue.prototype.BASE_URL =  (process.env.NODE_ENV === 'development' ? "https://oaserver.yanhuotiyu.com/oa" : "https://oaserver.yanhuotiyu.com/oa");
  // Vue.prototype.BASE_URL =  (process.env.NODE_ENV === 'development' ? "http://192.168.30.43:9999" : "https://oaserver.yanhuotiyu.com/oa");
  // Vue.prototype.BASE_URL =  (process.env.NODE_ENV === 'development'? "http://192.168.30.22:9999": "https://oaserver.yanhuotiyu.com/oa");

  Vue.prototype.$isNotEmpty = function(obj){
    return (obj !== undefined && obj !== null && obj !== '' && obj !== 'null')
  }

Vue.prototype.$getDefalut = function(obj, key, df){
  return (obj === undefined || key === undefined || !this.$isNotEmpty(obj[key])) ? df : obj[key];
}

Vue.prototype.$deepCopy = function (obj){return JSON.parse(JSON.stringify(obj))}

//字符串超过5个的就是返回...
Vue.filter('truncate', function(value, length = 5) {
  if (!value) return ''; // 处理空值
  return value.length > length ? value.slice(0, length) + '...' : value;
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')












